import styled from 'styled-components';
import { useLangContext } from '../../../providers/LangProvider/LangProviderContext';
import { LANDING_IMAGES } from '../landingAssets';

const LandingAdvantagesStyled = styled.section``;

const ADVANTAGES = [
    ['start', LANDING_IMAGES.icon01],
    ['admin', LANDING_IMAGES.icon07],
    ['analytics', LANDING_IMAGES.icon05],
    ['meta', LANDING_IMAGES.icon02],
    ['manager', LANDING_IMAGES.icon03],
    ['payments', LANDING_IMAGES.icon06],
];

function LandingAdvantages() {
    const { getLangPath } = useLangContext();

    return (
        <LandingAdvantagesStyled className="block white" id="advantages">
            <div className="wrap">
                <div className="section-head">
                    <div>
                        <div className="kicker">{getLangPath('landing.advantages.kicker')}</div>
                        <h2>
                            {getLangPath('landing.advantages.titleLine1')}
                            <br/>
                            {getLangPath('landing.advantages.titleLine2')}
                        </h2>
                    </div>
                </div>
                <div className="benefits partner-grid">
                    {ADVANTAGES.map(([key, icon]) => (
                        <article className="benefit partner-card" key={key}>
                            <div className="icon" aria-hidden="true">
                                <img src={icon} alt="" width="36" height="36"/>
                            </div>
                            <h3>{getLangPath(`landing.advantages.${key}Title`)}</h3>
                            <p>{getLangPath(`landing.advantages.${key}Text`)}</p>
                        </article>
                    ))}
                </div>
            </div>
        </LandingAdvantagesStyled>
    );
}

export default LandingAdvantages;
